import { PLENARY_DOCS_STATUS, PLENARY_DOCS_TYPES } from '../enums/enums';

export class PlenaryDoc {
  constructor(
    public id:          string,
    public name:        string,
    public title:       string,
    public description: string,
    public year:        string,
    public type:        PLENARY_DOCS_TYPES,
    public status:      PLENARY_DOCS_STATUS,
    public document:    string,
  ) { }
}